import _slicedToArray from "D:\\a\\1\\s\\rez-rate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import cn from 'classnames';
import React, { useEffect, useRef } from 'react';
import dates from './dates';
import useFocusManager from './useFocusManager';
function clamp(date, min, max) {
  return dates.max(dates.min(date, max), min);
}
function CalendarView(_ref) {
  var className = _ref.className,
    focusedItem = _ref.focusedItem,
    onKeyDown = _ref.onKeyDown,
    children = _ref.children,
    labelledby = _ref['aria-labelledby'];
  var ref = useRef(null);
  var _useFocusManager = useFocusManager(ref),
    _useFocusManager2 = _slicedToArray(_useFocusManager, 2),
    focusEvents = _useFocusManager2[0],
    focused = _useFocusManager2[1];
  useEffect(function () {
    var _node$querySelector;
    var node = ref.current;
    if (!node || !focused) return;
    (_node$querySelector = node.querySelector('.rw-cell[tabindex]')) == null ? void 0 : _node$querySelector.focus();
  }, [focusedItem, focused, ref]);
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "grid",
    ref: ref,
    tabIndex: -1
  }, focusEvents, {
    onKeyDown: onKeyDown,
    "aria-labelledby": labelledby,
    className: cn(className, 'rw-nav-view', 'rw-calendar-grid')
  }), children);
}
function CalendarViewCell(_ref2) {
  var onChange = _ref2.onChange,
    min = _ref2.min,
    max = _ref2.max,
    date = _ref2.date,
    unit = _ref2.unit,
    disabled = _ref2.disabled,
    selected = _ref2.selected,
    focusedItem = _ref2.focusedItem,
    viewUnit = _ref2.viewUnit,
    children = _ref2.children,
    label = _ref2.label;
  var isEqual = function isEqual(nextDate) {
    return dates.eq(date, nextDate, unit);
  };
  var isEmpty = !dates.inRange(date, min, max, unit);
  var isDisabled = disabled || isEmpty; // const isNow = now && isEqual(now)

  var isFocused = !disabled && !isEmpty && isEqual(focusedItem);
  var isSelected = selected && isEqual(selected);
  var isOffView = date && focusedItem && viewUnit && dates[viewUnit](date) !== dates[viewUnit](focusedItem);
  var handleChange = function handleChange() {
    onChange(clamp(date, min, max));
  };
  return /*#__PURE__*/React.createElement("div", {
    role: "gridcell",
    title: label,
    "aria-label": label,
    "aria-readonly": disabled,
    "aria-selected": Boolean(isSelected),
    tabIndex: isFocused ? 0 : void 0,
    onClick: !isDisabled ? handleChange : undefined,
    className: cn('rw-cell',
    // isNow && 'rw-now',
    isDisabled && 'rw-state-disabled', isEmpty && 'rw-cell-not-allowed', isOffView && 'rw-cell-off-range', isSelected && 'rw-state-selected')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, children));
}
CalendarView.Body = function (props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "rowgroup",
    className: "rw-calendar-body"
  }, props));
};
CalendarView.Row = function (props) {
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "row",
    className: "rw-calendar-row"
  }, props));
};
CalendarView.Cell = CalendarViewCell;
export default CalendarView;